import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=86e7cf58&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=ts"
export * from "./goodsDetail.vue?vue&type=script&lang=ts"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=86e7cf58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e7cf58",
  null
  
)

export default component.exports